/**
 * Hero-Komponente für die Startseite
 * Enthält Scroll-Indikator und Terminal-Animation
 */
export default function initHero() {
  // Scroll-Funktion für den Scroll-Down-Link
  const scrollIndicator = document.querySelector(".scroll-indicator-link");

  if (scrollIndicator) {
    scrollIndicator.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // Prüfen auf reduzierte Bewegung
        const prefersReducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;

        if (
          !prefersReducedMotion &&
          "scrollBehavior" in document.documentElement.style
        ) {
          targetElement.scrollIntoView({
            behavior: "smooth",
          });
        } else {
          targetElement.scrollIntoView();
        }
      }
    });
  }

  // Terminal-Animation
  setTimeout(() => {
    const originalContent = document.getElementById("terminal-content");
    const animatedContent = document.getElementById("animated-content");

    if (!originalContent || !animatedContent) return;

    // Prüfen, ob der Nutzer reduzierte Bewegung bevorzugt
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (prefersReducedMotion) {
      // Bei Präferenz für reduzierte Bewegung: Inhalt direkt anzeigen ohne Animation
      animatedContent.innerHTML = originalContent.innerHTML;
      return;
    }

    // Erhalte den HTML-Inhalt, einschließlich aller Leerzeichen und Zeilenumbrüche
    const htmlContent = originalContent.innerHTML;

    // Setze den Inhalt als HTML in das Animation-Element
    animatedContent.innerHTML = htmlContent;

    // Sammle alle Textknoten im animierten Inhalt
    const animatedSpans = animatedContent.querySelectorAll("span");
    const originalSpans = originalContent.querySelectorAll("span");

    // Speichere den Originaltext und leere die Spans
    const originalTexts = [];
    animatedSpans.forEach((span, index) => {
      originalTexts.push(span.textContent);
      span.textContent = "";
      span.className = originalSpans[index].className;
    });

    // Animiere jeden Span nacheinander
    let currentSpanIndex = 0;

    function animateNextSpan() {
      if (currentSpanIndex >= animatedSpans.length) return;

      const animatedSpan = animatedSpans[currentSpanIndex];
      const originalText = originalTexts[currentSpanIndex];

      let charIndex = 0;
      const cursor = document.createElement("span");
      cursor.className = "typed-cursor";
      animatedSpan.appendChild(cursor);

      const typeInterval = setInterval(() => {
        if (charIndex < originalText.length) {
          // Füge Text vor dem Cursor ein
          animatedSpan.insertBefore(
            document.createTextNode(originalText.charAt(charIndex)),
            cursor,
          );
          charIndex++;
        } else {
          // Entferne Cursor am Ende einer Zeile
          animatedSpan.removeChild(cursor);
          clearInterval(typeInterval);
          currentSpanIndex++;

          // Auto-Scroll zum Ende des Containers
          animatedContent.parentElement.parentElement.scrollTop =
            animatedContent.parentElement.parentElement.scrollHeight;

          // Warte einen Moment vor der nächsten Zeile
          setTimeout(animateNextSpan, 200);
        }
      }, 30);
    }

    // Starte die Animation
    animateNextSpan();
  }, 1000);
}
